import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import Immutable from 'immutable';

// action creators
import { doneIndicator, success } from 'store/actions/httpActions';

// api
import client from 'sources/api';

// constants
import {
  GROUP_VALUE_CREATE_REQUEST,
  GROUP_VALUE_CREATE,
} from 'store/constants/groupValueTypes';
import { GROUP_FIELD_FETCH } from 'store/constants/groupFieldTypes';

// schemas
import { groupValueSchema } from 'store/schemas/groupValueSchema';
import { groupFieldSchema } from 'store/schemas/groupFieldSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';
import getResponsePayload from 'helpers/getResponsePayload';

const WATCH_TYPE = GROUP_VALUE_CREATE_REQUEST;
const TYPE = GROUP_VALUE_CREATE;

export function* createGroupValue(action: any) {
  const FORM = action.payload.formName;

  const {
    payload: { groupId, label, description },
  } = action;

  const META_ID = `create-${label}`;

  let response;

  const endpoint = `/group_values?group_id=${groupId}`;

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  response = yield* httpSaga(
    TYPE,
    call(client.post, endpoint, {
      label,
      description,
    }),
    {
      dispatchSuccess: false,
      schema: groupValueSchema,
      metaId: META_ID,
      formName: FORM,
    }
  );

  // Refetches group fields, since changes to group fields happen via the database
  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    GROUP_FIELD_FETCH,
    call(client.get, '/group_fields', {
      params: { group_id: groupId },
    }),
    {
      schema: [groupFieldSchema],
      resultKey: 'valuesResult',
    }
  );

  const payload = getResponsePayload(response, groupValueSchema);

  // Send the response data to the store for this type to be caught by a reducer
  yield put(
    success(
      TYPE,
      Immutable.fromJS({
        ...payload,
      }),
      META_ID
    )
  );

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, createGroupValue);
}

export default function* root() {
  yield all([fork(watch)]);
}
